/* Click handler factory for <button>-styled CTAs that drive navigation.

   The site uses full-page reloads for navigation (each route is a
   separate Insites-rendered Liquid page), so a button just needs to set
   window.location.href on click.

   Cmd/Ctrl-click → open in new tab. This recovers the browser-native
   right-click affordance that's lost when an <a href> is converted to
   a <button>. Middle-click is harder to capture portably (the click
   event runs only on left/right clicks); power users wanting middle-
   click "open in new tab" should use cmd/ctrl-click instead.

   target: 'blank' forces window.open regardless of modifier keys —
   matches the semantic of <a href target="_blank">. */

export interface NavigateOptions {
  target?: '_blank'
}

export function navigateTo(
  url: string,
  options: NavigateOptions = {},
): React.MouseEventHandler<HTMLElement> {
  return (event) => {
    if (options.target === '_blank' || event.metaKey || event.ctrlKey) {
      window.open(url, '_blank', 'noopener,noreferrer')
      return
    }
    window.location.href = url
  }
}
